export function pickFields(obj, fields) {
    if (fields === null) {
        return { ...obj };
    }

    const result = {};
    fields.forEach((field) => {
        result[field] = obj[field];
    });

    return result;
}
